/** Cửa hàng cosmetic M3: trang trí tiệm + đồng phục, mua bằng xu cao cấp. */
import type { GameController } from '../game-controller.js';
import { styleNutChinh, stylePanel, useCapNhat } from '../dung-chung.js';
import { toast } from './Toast.js';

export function PanelCosmetic(props: { controller: GameController }) {
  const { controller } = props;
  useCapNhat(controller);
  const { state, duLieu } = controller;
  const nd = new Map(duLieu.noiDungCosmetic.map((n) => [n.ma, n]));
  const soHuu = new Set(state.cosmeticSoHuu);

  const bamMua = (ma: string): void => {
    try {
      controller.muaCosmetic(ma);
      toast('Đã mua! 💎');
    } catch (e) {
      toast(e instanceof Error ? e.message : 'Không mua được.');
    }
  };

  const bamDung = (ma: string): void => {
    try {
      controller.dungCosmetic(ma);
      toast('Đã dùng! ✨');
    } catch (e) {
      toast(e instanceof Error ? e.message : 'Không dùng được.');
    }
  };

  return (
    <div style={stylePanel}>
      <h3 style={{ margin: '0 0 8px' }}>🎨 Trang trí & đồng phục</h3>
      <p style={{ fontSize: '13px', opacity: 0.85, margin: '0 0 8px' }}>
        Xu cao cấp: <strong>{state.xuCaoCap} 💎</strong> (kiếm từ thành tựu, sưu tập, đơn lớn).
      </p>
      {duLieu.cosmetic.cosmetic.map((c) => {
        const co = soHuu.has(c.ma);
        const ten = nd.get(c.ma)?.ten ?? c.ma;
        const moTa = nd.get(c.ma)?.moTa ?? '';
        const dangDung =
          (c.loai === 'trangTri' && state.cosmeticTrangTri === c.ma) ||
          (c.loai === 'dongPhuc' && state.cosmeticDongPhuc === c.ma);
        return (
          <div
            key={c.ma}
            style={{
              border: '1px solid #8a6a3a',
              borderRadius: '8px',
              padding: '8px',
              marginBottom: '6px',
            }}
          >
            <div style={{ fontWeight: 700 }}>
              {ten} {dangDung ? '✨ đang dùng' : ''}
            </div>
            <div style={{ fontSize: '12px', opacity: 0.85 }}>{moTa}</div>
            <div style={{ marginTop: '4px', display: 'flex', gap: '8px' }}>
              {!co && (
                <button style={styleNutChinh} onClick={() => bamMua(c.ma)}>
                  Mua ({c.giaXuCaoCap} 💎)
                </button>
              )}
              {co && !dangDung && (
                <button style={styleNutChinh} onClick={() => bamDung(c.ma)}>
                  Dùng
                </button>
              )}
            </div>
          </div>
        );
      })}
      <p style={{ fontSize: '12px', opacity: 0.7 }}>
        Đang dùng: trang trí {state.cosmeticTrangTri ?? 'mặc định'}, đồng phục{' '}
        {state.cosmeticDongPhuc ?? 'mặc định'}.
      </p>
    </div>
  );
}
